module.exports = __webpack_public_path__ + "static/media/d18kz.69ddc0fd.pdf";